var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:"monitorIfScrolledImage",class:_vm.inView ? 'in-view' : '',attrs:{"data-animation":"offset"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }